'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */

var LayoutView = require('base/Colido.LayoutView');
var Util = require('base/Colido.Util');
var ExportUnfinishedList = require('../partials/export-unfinished-list');
var ExportRecentList = require('../partials/export-recent-list');

var template = require('modules/settings/templates/layout/export.hbs');

var ExportLayout = LayoutView.extend({

    template: template,

    className: 'settings settings-export',

    ui: {
        exportAbort:  '[data-action="abort"]',
        exportDatabase:  '[data-action="export"]',
    },

    events: {
        'click @ui.exportDatabase': 'actionExportDatabase',
        'click @ui.exportAbort': 'exportAbort',
    },

    regions: {
        unfinishedExportsRegion: '.unfinished-exports-region',
        recentExportsRegion: '.recent-exports-region',
    },

    /**
     * Collection for the unfinished items
     * @type {Colido.Collection}
     */
    collectionUnfinished: null,

    /**
     * Collection for the finished items
     * @type {Colido.Collection}
     */
    collectionFinished: null,

    initialize: function(options) {
        LayoutView.prototype.initialize.apply(this, arguments);

        this.collectionUnfinished = this.collection.unfinished();
        this.collectionFinished = this.collection.finished();

        this.listenTo(this.collectionUnfinished, 'add remove sync change', this.checkListRegions.bind(this));
        this.listenTo(this.collectionFinished, 'add remove sync change', this.checkListRegions.bind(this));
        App.radio().trigger('collection:exports:reload');
    },

    onBeforeShow: function() {
        this.unfinishedExportsRegion.show(new ExportUnfinishedList({
            collection: this.collectionUnfinished,
        }));

        this.recentExportsRegion.show(new ExportRecentList({
            collection: this.collectionFinished,
        }));

        this.checkListRegions();
    },

    /**
     * Action for exporting a new database
     */
    actionExportDatabase: function() {
        App.router.navigate('/export', {trigger: true});
    },

    /**
     * Action for aborting an export
     * @param event
     */
    exportAbort: function(event) {
        var $button = $(event.currentTarget);
        var id = $(event.currentTarget).data('id');

        $button.addClass('is-loading');
        alert('not implemented yet');
        $button.removeClass('is-loading');
    },

    /**
     * Checks, if the regions with the lists should be shown
     */
    checkListRegions: function() {
        this.collection.sortByFields();
        this.$el.toggleClass('has-unfinished', this.collectionUnfinished.length > 0);
        this.$el.toggleClass('has-finished', this.collectionFinished.length > 0);
    },
});

module.exports = ExportLayout;